:host {
  @apply block overflow-hidden;
}

.flyoutmenu-item {
  @apply select-none rounded-none border-none font-button text-copy-small text-left bg-white text-black cursor-pointer;
  line-height: 20px;
  padding: 8px 24px;
  margin: 0;

  .ellipsis {
    @apply truncate;
  }

  &:focus {
    outline: 0;
  }

  &:hover {
    @apply bg-gray-100;
  }

  &:disabled {
    @apply text-gray-400;
  }

  &.subtle {
    @apply font-text;
  }
}
